module.exports = __webpack_public_path__ + "static/media/left.cd076545.svg";